export const VELKI_GAME_GROUPS = [
  { key: "Live", label: "Live", gameType: "LIVE" },
  { key: "Table", label: "Table", gameType: "TABLE" },
  { key: "Slot", label: "Slot", gameType: "SLOT" },
  { key: "Fishing", label: "Fishing", gameType: "FH" },
  { key: "Egame", label: "Egame", gameType: "EGAME" },
] as const;

export const VELKI_GROUP_KEYS = [
  "Live",
  "Table",
  "Slot",
  "Fishing",
  "Egame",
  "Other",
];

export type LiveCatalog = {
  key: string;
  label: string;
  count: number;
};

export const velkiGroupFromGameType = (gameType?: string) => {
  const value = String(gameType || "").trim().toLowerCase();
  if (value === "live") return "Live";
  if (value === "table") return "Table";
  if (value === "slot") return "Slot";
  if (value === "fh" || value === "fishing") return "Fishing";
  if (value === "egame" || value === "esports") return "Egame";
  return "";
};

export const canonicalVelkiGameType = (group?: string) =>
  VELKI_GAME_GROUPS.find((item) => item.key === group)?.gameType || "";

export const formatVelkiGameType = (gameType?: string) => {
  const group = velkiGroupFromGameType(gameType);
  if (group) return group;
  const raw = String(gameType || "").trim();
  return raw || "—";
};
